import { Controller } from "remult";

@Controller("opportunity-reports-methods")
export class OpportunityReportMethods {}
